import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { armaService } from '../services/armas.service'
import type { ArmaFilters } from '../types'

export const ARMAS_KEY = 'armas'

export function useArmas(filters: ArmaFilters = {}) {
  return useQuery({
    queryKey: [ARMAS_KEY, filters],
    queryFn: () => armaService.list(filters),
  })
}

export function useCreateArma() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: armaService.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: [ARMAS_KEY] }),
  })
}

export function useUpdateArma() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) => armaService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ARMAS_KEY] }),
  })
}

export function useDeleteArma() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => armaService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [ARMAS_KEY] }),
  })
}
